<template>
  <span>
    <slot name="modal-toggle-btn" v-bind:toggleClick="clickToggleTrue"></slot>
    <el-dialog
      :title="title"
      :width="width || '640px'"
      :custom-class="customClass"
      :visible.sync="visible"
      :before-close="handleCancel"
      :append-to-body="appendToBody || true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <div v-if="visible">
        <slot name="modal-content" v-bind:dataState="dataState"></slot>
      </div>
    </el-dialog>
  </span>
</template>

<script>

export default {
  name: 'Modal',
  props: {
    title: String,
    width: String,
    customClass: String,
    beforeClose: Function,
    appendToBody: Boolean,
  },
  data() {
    return {
      visible: false,
      dataState: {
        handleCancel: () => this.handleCancel(),
        clickToggleTrue: () => this.clickToggleTrue()
      }
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
    },
    clickToggleTrue() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.click-toggle-box {
  display: inline-block;
}
</style>
